import React from 'react';
import { Card, Col, Row, Space, Tag, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

export default function StyleCandidateSelector({ candidates, value, onChange }) {
  return (
    <div style={{ maxHeight: 250, overflowY: 'auto', paddingRight: 4 }}>
      <Row gutter={[12, 12]}>
        {(candidates || []).map((candidate) => {
          const selected = value === candidate.id;
          return (
            <Col xs={24} md={12} xl={8} key={candidate.id}>
              <Card
                hoverable
                onClick={() => onChange(candidate.id)}
                bodyStyle={{ padding: 14 }}
                style={{
                  borderRadius: 14,
                  borderColor: selected ? '#2563eb' : '#e5e7eb',
                  boxShadow: selected
                    ? '0 0 0 2px rgba(37,99,235,0.12), 0 8px 18px rgba(37,99,235,0.08)'
                    : '0 3px 12px rgba(15,23,42,0.04)',
                  background: selected ? '#f8fbff' : '#fff',
                }}
              >
                <Space direction="vertical" size={10} style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
                    <div>
                      <Text strong style={{ fontSize: 15, color: '#111827' }}>{candidate.name}</Text>
                      <div style={{ marginTop: 4 }}>
                        <Tag color={candidate.confidence >= 0.75 ? 'green' : 'gold'} style={{ borderRadius: 999, fontWeight: 600, marginInlineEnd: 0 }}>
                          {Math.round((candidate.confidence || 0) * 100)}%
                        </Tag>
                      </div>
                    </div>
                    {selected ? <CheckCircleFilled style={{ color: '#2563eb', fontSize: 16 }} /> : null}
                  </div>

                  <Paragraph style={{ marginBottom: 0, color: '#374151', minHeight: 40 }}>
                    {candidate.description}
                  </Paragraph>

                  <div style={{ padding: '10px 12px', borderRadius: 12, background: '#f8fafc', border: '1px solid #e5e7eb' }}>
                    <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 6 }}>Câu trả lời mẫu</Text>
                    <Text style={{ color: '#111827', lineHeight: 1.6 }}>{candidate.sampleReply}</Text>
                  </div>

                  <Space wrap size={[6, 6]}>
                    {(candidate.keyPhrases || []).map((phrase) => (
                      <Tag key={phrase} style={{ borderRadius: 999, paddingInline: 10, background: '#fff', borderColor: '#dbeafe', color: '#1d4ed8', marginInlineEnd: 0 }}>
                        {phrase}
                      </Tag>
                    ))}
                  </Space>
                </Space>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
